module.exports = __webpack_public_path__ + "img/icon1.1e2ac7fd.png";